<template>
  <div class="charts pie_charts" :class="{bgColorEcharts:!!dailyKData.length}">
    <v-chart :options="kOptions" autoresize></v-chart>
  </div>
</template>

<script>
var upColor = "#ec0000";
var upBorderColor = "#8A0000";
var downColor = "#00da3c";
var downBorderColor = "#008F28";

function splitData(rawData) {
  var categoryData = [];
  var values = [];
  for (var i = 0; i < rawData.length; i++) {
    categoryData.push(rawData[i].splice(0, 1)[0]);

    values.push(rawData[i]);
  }
  const vdata = {
    categoryData: categoryData,
    values: values
  };

  return vdata;
}

// 数据意义：开盘(open)，收盘(close)，最低(lowest)，最高(highest)
var data0 = splitData([
  ["2013/1/24", 2320.26, 2320.26, 2287.3, 2362.94],
  ["2013/1/25", 2300, 2291.3, 2288.26, 2308.38],
  ["2013/1/28", 2295.35, 2346.5, 2295.35, 2346.92],
]);

export default {
  props: {
    dailyKData: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      kOptions: {}
    };
  },

  methods: {
    getOptions(data) {
      const formatData = splitData(this.$lodash.cloneDeep(data));

      return {
        title: {
          text: "Daily Quotation",
          left: 0
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        legend: {
          data: ["Daily K"]
        },
        grid: {
          x: 20,
          y: 50,
          x2: 20,
          y2: 50,
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: formatData.categoryData,
          scale: true,
          boundaryGap: false,
          axisLine: { onZero: false },
          splitLine: { show: false },
          splitNumber: 20,
          min: "dataMin",
          max: "dataMax"
        },
        yAxis: {
          scale: true,
          // boundaryGap:true,
          splitArea: {
            show: true
          }
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          },
          {
            show: true,
            type: "slider",
            y: "90%",
            start: 0,
            end: 100
          }
        ],
        series: [
          {
            name: "Daily K",
            type: "candlestick",
            data: formatData.values,
            itemStyle: {
              normal: {
                color: upColor,
                color0: downColor,
                borderColor: upBorderColor,
                borderColor0: downBorderColor
              }
            }
            // markPoint: {
            //   label: {
            //     normal: {
            //       formatter: function(param) {
            //         return param != null ? Math.round(param.value) : "";
            //       }
            //     }
            //   },
            //   data: [
            //     {
            //       name: "XX标点",
            //       coord: ["2013/5/31", 2300],
            //       value: 2300,
            //       itemStyle: {
            //         normal: { color: "rgb(41,60,85)" }
            //       }
            //     },
            //     {
            //       name: "highest value",
            //       type: "max",
            //       valueDim: "highest"
            //     },
            //     {
            //       name: "lowest value",
            //       type: "min",
            //       valueDim: "lowest"
            //     },
            //     {
            //       name: "average value on close",
            //       type: "average",
            //       valueDim: "close"
            //     }
            //   ],
            //   tooltip: {
            //     formatter: function(param) {
            //       return param.name + "<br>" + (param.data.coord || "");
            //     }
            //   }
            // },
            // markLine: {
            //   symbol: ["none", "none"],
            //   data: [
            //     [
            //       {
            //         name: "from lowest to highest",
            //         type: "min",
            //         valueDim: "lowest",
            //         symbol: "circle",
            //         symbolSize: 10,
            //         label: {
            //           normal: { show: false },
            //           emphasis: { show: false }
            //         }
            //       },
            //       {
            //         type: "max",
            //         valueDim: "highest",
            //         symbol: "circle",
            //         symbolSize: 10,
            //         label: {
            //           normal: { show: false },
            //           emphasis: { show: false }
            //         }
            //       }
            //     ],
            //     {
            //       name: "min line on close",
            //       type: "min",
            //       valueDim: "close"
            //     },
            //     {
            //       name: "max line on close",
            //       type: "max",
            //       valueDim: "close"
            //     }
            //   ]
            // }
          }
        ]
      };
    }
  },

  watch: {
    dailyKData: {
      handler(newValue) {
        this.kOptions = this.getOptions(newValue);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.charts {
  height: 600px;
  padding: 20px;
  border: 1px solid #dce2ea;
  margin-top: 20px;
}
</style>